<template>
  <div class="signature" @touchmove.prevent>
    <div class="bar jc-sb" style="background: rgba(0, 0, 0, 0.3)">
      <!-- <div ></div> -->
      <div class="item" style="width: 250px; text-align: center">
        绘制个人签名
      </div>
      <!-- <div class="item"><van-icon name="arrow-left" /></div> -->
    </div>
    <div class="outside">
      <div class="boardBox" ref="boardBox">
        <canvas
          ref="board"
          id="canvas"
          @touchstart="mStart"
          @touchmove="mMove"
          @touchend="mEnd"
        ></canvas>
      </div>
    </div>

    <div class="bar">
      <div class="item" @click="goleft">
        <div class="ico">
          <img src="../../assets/img/client/toleft.png" alt srcset />
        </div>
        <div class="text">左移</div>
      </div>
      <div class="item" @click="getcanvas">
        <div class="ico">
          <img src="@/assets/img/client/keep.png" alt srcset />
        </div>
        <div class="text">保存</div>
      </div>
      <div class="item" @click="clearcanvas">
        <div class="ico">
          <img src="@/assets/img/client/reset.png" alt srcset />
        </div>
        <div class="text">重签</div>
      </div>
      <!-- <div class="item" @click="goback">
        <div class="ico">
          <img src="../../assets/img/client/out.png" alt srcset />
        </div>
        <div class="text">退出</div>
      </div> -->
      <div class="item" @click="goright">
        <div class="ico">
          <img src="../../assets/img/client/toright.png" alt  />
        </div>
        <div class="text">右移</div>
      </div>
    </div>
  </div>
</template>
<script>
import { client } from "../../utils/alioss";
import { NavBar } from "vant";
export default {
  components: {
    NavBar,
  },
  data() {
    return {
      familysignatureurl: "",
      basedata: "",
      ctx: null,
      point: {
        x: 0,
        y: 0,
      },
      moving: false, // 是否正在绘制中且移动
      w: "",
      h: "",
      url:''
    };
  },
  mounted() {
    window.addEventListener("resize", this.renderResize, false);
    let a = document.getElementsByClassName("outside");
    console.log(document.documentElement.clientHeight);
    let board = this.$refs.board; // 获取DOM
    this.$refs.boardBox.style.width=document.documentElement.clientHeight
    board.width = this.$refs.boardBox.offsetWidth; // 设置画布宽
    board.height = this.$refs.boardBox.offsetHeight; // 设置画布高
    this.w = this.$refs.boardBox.offsetWidth;
    this.h = this.$refs.boardBox.offsetHeight;
    console.log(board.width, board.height);
    this.ctx = board.getContext("2d"); // 二维绘图
    this.ctx.strokeStyle = "#000"; // 颜色
    this.ctx.lineWidth = 3; // 线条宽度
  },
  methods: {
    // 触摸(开始)
    mStart(e) {
      let a = document.getElementsByClassName("outside")[0];
      let x = e.touches[0].clientX - e.target.offsetLeft+a.scrollLeft,
        y = e.touches[0].clientY - e.target.offsetTop+a.scrollTop; // 获取触摸点在画板（canvas）的坐标
      this.point.x = x;
      this.point.y = y;
      this.ctx.beginPath();
      this.moving = true;
    },
    // 滑动中...
    mMove(e) {
      if (this.moving) {
        let a = document.getElementsByClassName("outside")[0];
        let x = e.touches[0].clientX - e.target.offsetLeft+a.scrollLeft,
          y = e.touches[0].clientY - e.target.offsetTop+a.scrollTop; // 获取触摸点在画板（canvas）的坐标
        this.ctx.moveTo(this.point.x, this.point.y); // 把路径移动到画布中的指定点，不创建线条(起始点)
        this.ctx.lineTo(x, y); // 添加一个新点，然后创建从该点到画布中最后指定点的线条，不创建线条
        this.ctx.stroke(); // 绘制
        // if(thi)
        (this.point.x = x), (this.point.y = y); // 重置点坐标为上一个坐标
      }
    },
    // 滑动结束
    mEnd() {
      if (this.moving) {
        this.ctx.closePath(); // 停止绘制
        this.moving = false; // 关闭绘制开关
      }
    },
    getcanvas() {
      let blank = document.createElement("canvas");
      //绘画转图片
      let canvas = document.getElementById("canvas");
      blank.width = canvas.width;
      blank.height = canvas.height;
      console.warn(canvas.toDataURL() === blank.toDataURL(), "判断白板");
      canvas.toDataURL("image/png");
      this.basedata=canvas.toDataURL("image/png")
      console.log(this.url)
      if (canvas.toDataURL() !== blank.toDataURL()) {
        sessionStorage.setItem("issign", 1);
      } else {
        sessionStorage.removeItem("issign");
      }
     this.updatavue();
      // document.getElementById("canvas").toBlob(async (blobObj) => {
      //   var file1 = new File([blobObj], "pic.png", {
      //     type: blobObj.type,
      //     lastModified: Date.now(),
      //   });
      //   console.log(file1)
      //   this.convertImg(file1);
      // });
    },
    //旋转图片
    convertImg(file) {
      let _this = this;
      var canvas1 = document.createElement("canvas");
      var context1 = canvas1.getContext("2d");
      var oReader = new FileReader();
      oReader.readAsDataURL(file);
      oReader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          // 图片原始尺寸
          var originWidth = this.width;
          var originHeight = this.height;
          // 最大尺寸限制
          var maxWidth = 1080,
            maxHeight = 1080;
          // 目标尺寸
          var targetWidth = originWidth,
            targetHeight = originHeight;
          // 图片尺寸超过300x300的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              targetWidth = maxWidth;
              targetHeight = Math.round(
                maxWidth * (originHeight / originWidth)
              );
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(
                maxHeight * (originWidth / originHeight)
              );
            }
          }
          var type = "image/png";
          // canvas对图片进行缩放
          canvas1.width = targetHeight;
          canvas1.height = targetWidth;
          // 旋转90度
          context1.translate(0, 0);
          context1.rotate(Math.PI / 2);
          // (0,-imgHeight) 从旋转原理图那里获得的起始点
          // context.clearRect(0,  -targetHeight, targetWidth, targetHeight);
          context1.drawImage(img, 0, -targetHeight, targetWidth, targetHeight);
          // 将canvas的透明背景设置成白色
          var imageData = context1.getImageData(
            0,
            0,
            canvas1.width,
            canvas1.height
          );
          for (var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的，则设置成白色
            if (imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          context1.putImageData(imageData, 0, 0);
          var dataurl = canvas1.toDataURL(type);
          _this.basedata = dataurl;
          _this.updatavue();
        };
      };
    },
    //base64转Blob
    base64ToBlob(base64Data) {
      let arr = base64Data.split(","),
        fileType = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        l = bstr.length,
        u8Arr = new Uint8Array(l);

      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
        type: fileType,
      });
    },
    //上传图片
    async updatavue() {
      //转成file文件
      let blobObj = this.base64ToBlob(this.basedata);
      this.url=blobObj
      var file = new File([blobObj], "pic.png", {
        type: blobObj.type,

        lastModified: Date.now(),
      });

      //此处为发送请求给后台获取图片路径
      //   let res = await upload(file);
      var fileName = "/sign/" + `${Date.parse(new Date())}` + ".png";
      client()
        .put(fileName, file)
        .then((result) => {
          //此处为给自己属性进行赋值，http后面的代码很有可能会和我的不一样，一切与自己阿里云上的数据为准

          this.$emit("keep", result.res.requestUrls[0]);
          console.log(result.res.requestUrls[0]);
        });
      //   this.familysignatureurl=res.details.data.filePath
      //   console.log(this.familysignatureurl);//此处打印的为绘画的图片url
    },
    //清除画布
    clearcanvas() {
      var c = document.getElementById("canvas");
      var cxt = c.getContext("2d");
      c.height = c.height;
      this.ctx.lineWidth = 3;
    },
    //返回上一级
    goback() {
      this.$emit("out");
    },
    renderResize() {
      // 判断横竖屏
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      // if(width > height) {
      //     alert('横屏')
      // }
      // 做页面适配
      // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
    },
    goright() {
      let a = document.getElementsByClassName("outside")[0];
      console.log(a);
      if (a.scrollWidth > a.scrollLeft) {
        a.scrollLeft += 100;
      } else {
        a.scrollLeft = a.scrollWidth;
      }

      console.log(a.scrollLeft);
    },
    goleft(){
       let a = document.getElementsByClassName("outside")[0];
      console.log(a);
      if (a.scrollLeft<0) {
         a.scrollLeft =0;
      } else {
      
         a.scrollLeft -= 100;
      }
    }
  },
};
</script>



<style lang="less" scoped>
.signature {
  // display: flex;
  width: 100vw;
  // overflow: hidden;
  .loadingtext {
    // transform: rotate(-90deg);
    color: red;
  }
  .item {
    // -webkit-transform: rotate(-90deg);
    width: 40px;
  }

  .text {
    text-align: center;
    font-size: 15px;
  }

  .boardBox {
    width:750px;
    height:100%;
    border: 3px solid  #4b3232;
    background: #fff;
  }
  .outside {
    width: 100vw;
    height: 80vh;
    // background: #4b3232;
    overflow-x: auto;
    overflow-y: auto;
    // padding: 10px;
  }
  .bar {
    box-sizing: border-box;
    padding: 0rem 20px;
    display: flex;
    width: 100vw;
    height: 10vh;
    background-color: #ffffff;
    justify-content: space-around;
    align-items: center;
    // flex-direction: column;
  }
  .shade {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    background-color: #333333;
    z-index: 66666;
    opacity: 0.9;
    .minishade {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ico {
    text-align: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
